<template>
    <div> 
        <v-card color=""
            tile="" 
            flat="" 
            :min-height="height"
            >  
            <!-- //NO SELECTED ITEMS -->
             
             <v-card color="transparent" flat class="ma-2" v-if="!MBS.actions.SIZE(SELECTED_ITEMS)" :height="vsh-480">
                <br>
                 <v-layout  fill-height align-center justify-center>
                     <v-chip large color="b1" >
                         <v-icon class="mx-5" color="grey">mdi-tag</v-icon>
                         <span class="grey--text  mr-5">
                             No Selected Item
                         </span>
                     </v-chip>
                 </v-layout>
             </v-card>
    
            <!-- //TABLE VIEW -->
            <div v-else-if="true"> 
                <v-simple-table  class="  mr-2 ml-4" dense 
                    :height="height?height:(vsh-250)" fixed-header >
                    <!-- <template v-slot:default>
                    </template> -->
                    <thead>  
                        <tr class="font-weight-bold "> 
                            <th class="ma-0 pa-0 " style="width:'5px'"> 
                                <v-switch :inset="false"    style="height: ; margin: 5px;"
                                    v-model="item_multiple_select"
                                    label=""   hide-details
                                    class="ml-1"
                                ></v-switch> 
                            </th>
                            <th class=" text-left b  ">
                                BARCODE
                            </th>
                            <th class=" text-left b  ">
                                ITEM NAME
                            </th>
                            
                            <!-- <th class="text-center b  "> 
                                COST PRICE 
                            </th>
                            <th class="text-center b  "> 
                                RETAIL PRICE 
                            </th>
                            <th class="text-center b  "> 
                                WHOLESALE PRICE 
                            </th>  -->
                            <!-- <th class="text-center  b  ">
                                INITIAL STOCK 
                            </th> -->
                            <th class="text-center  b  ">
                               NO. COUNTS  
                            </th>
                            <th class="text-center  b  ">
                                T. COUNTED STOCK  
                            </th>
                            <!-- <th class="text-center  b  ">
                                DISCREPANCY  
                            </th> -->
                            
                            <!-- <th class="text-center  b  "> 
                            </th>  -->

                        </tr>
                         
                        <!-- <v-divider /> -->
                    </thead>
                    <tbody>
                        <tr class="pointer "  
                            v-for="(item,index) in item_data"
                            :key="item.key" 
                            :class="item.checked?'checked':''"
                            @click="ON_EDIT_SELECTED_ITEM(item,index)"
                            @mousedown="startLongClick"
                            @mouseup="endLongClick"
                            > 
                            <td class=" text-center with-divider-lr  ma-0 pa-0 table-background1" style="width:40px;"> 
                                <v-simple-checkbox @click.stop="" class="ma-0 pa-0"
                                    v-if="item_multiple_select" icon 
                                    color="primary" 
                                    :value="item.checked" 
                                    @input="INPUT_UPDATE($event, item,true)" 
                                    />  
                                <span v-else icon >
                                    <!-- <v-icon v-if="item.expand">expand_more</v-icon>
                                    <v-icon v-else>chevron_right</v-icon> -->
                                    <v-img v-if="item.image"></v-img>
                                    <v-icon v-else-if="item.item_not_counted">{{"local_offer"}}</v-icon>
                                    <v-icon v-else>{{item.uploaded?"mdi-cloud-check":"mdi-progress-upload"}}</v-icon>
                                </span>  
                            </td>
                            <td class=" with-divider ">
                                {{ item.code }}
                            </td>
                            <td class=" with-divider ">
                                {{ item.name }}
                            </td> 
                            <td class=" text-center with-divider ">
                                {{ item.total_counted_number }}
                            </td>
                            <td class=" text-center with-divider ">
                                {{ item.total_counted_stock }}
                            </td> 
                        </tr>
                        <v-divider />
                    </tbody>
                </v-simple-table> 
            </div> 
        </v-card>

        <!-- //DIALOGS -->
        <div>
            <!-- EDIT ITEM DIALOG -->
            <v-dialog
                v-model="dialog_edit_selected_item"
                :scrollable="true"  
                :persistent="true" :overlay="true"
                max-width="800px"
                transition="dialog-transition" >
                <v-card height="100%" rounded="sm" color="b1"  >
                    <v-card-title class="primary pa-2" >
                        <v-layout row wrap justify-center align-center class="mx-2 my-0">
                            <v-flex >
                                <v-list-item dark>
                                    <v-list-item-action>
                                        <v-icon>mdi-tag</v-icon> 
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ CURRENT_SELECTED_ITEM?.name }}</v-list-item-title> 
                                        <v-list-item-subtitle>{{ CURRENT_SELECTED_ITEM?.category_name }}</v-list-item-subtitle>  
                                    </v-list-item-content>  
                                </v-list-item>
                                
                            </v-flex>
                            <v-btn outlined dark>T. COUNTED STOCK: {{CURRENT_SELECTED_ITEM?.total_counted_stock}}</v-btn> 
                            <v-btn dark @click="dialog_edit_selected_item=!dialog_edit_selected_item" icon><v-icon>close</v-icon></v-btn> 
                        </v-layout>
                    </v-card-title>
                    <div outlined class="mbs-borders mx-2 mt-2 mb-2 pa-2" :style="'--size:1px; --color:grey; --conner:3px'">
                        <form @submit.prevent="UPDATE_SELECTED_ITEM({
                            item:CURRENT_SELECTED_ITEM,
                            self_contain:true,
                            input
                        })">
                            <v-card-text class="b1">
                                <v-card outlined class="mx-2" v-if="CURRENT_SELECTED_ITEM?.joined_counted_stocks">
                                    <v-simple-table   class="  mr-2 ml-4" dense 
                                        :height="height?height:(200)" fixed-header > 
                                        <thead>  
                                            <tr class="font-weight-bold ">  
                                                <th class=" text-left b  ">
                                                    Time
                                                </th>
                                                <th class=" text-left b  ">
                                                    User
                                                </th><th class=" text-left b  ">
                                                    Location
                                                </th>
                                                <th class=" text-right b  ">
                                                    Stock Count
                                                </th> 
                                                <th></th>
                                            </tr> 
                                        </thead>
                                        <tbody>
                                            <tr class="pointer "  
                                                v-for="(item,index) in CURRENT_SELECTED_ITEM?.joined_counted_stocks"
                                                :key="item.key" 
                                                :class="item.checked?'checked':''"> 

                                                <td class=" with-divider ">
                                                    {{ item.local_created_at_time }}
                                                </td>
                                                <td class=" with-divider ">
                                                    {{ item.counter_user_name }}
                                                </td> 
                                                <td class=" with-divider ">
                                                    {{ item.counted_stock_quantity_location }}
                                                </td>
                                                <td class=" with-divider ">
                                                    {{ item.counted_stock_quantity }}
                                                </td> 
                                                <td class=" text-center with-divider-lr  px-2">
                                                    <v-btn icon class="ma-0 pa-0" @click.stop="CONFIRM_REMOVE_ITEM(item,index)"><v-icon>delete</v-icon></v-btn>
                                                </td>
                                            </tr>
                                             
                                            <v-divider />
                                        </tbody>
                                    </v-simple-table> 
                                </v-card >

                                <v-card outlined class="mt-">
                                    <v-layout row class="ma-0 px-3 " justify-center align-center>
                                        <div class="font-weight-bold not-f2 mr-2 ">New Stock Count</div>
                                        <v-flex >
                                            <v-text-field :class="vs?.xs?'':'mt-1 mr-1'" dense
                                                append-icon="mdi-selection-marker"
                                                filled outlined hint="Location"
                                                v-model="input_quantity_location"
                                                @focus="FOCUS_INPUT({value:'field_input_quantity_location',
                                                ref:'ref_current_selected_item_quantity'})"
                                                outline />  
                                        </v-flex>
                                        <v-flex xs12 sm3>
                                            <v-text-field class="mt-1 " dense autofocus
                                                    filled outlined append-icon="mdi-counter"
                                                    v-model="input_quantity" type="number"
                                                    @focus="FOCUS_INPUT({value:'field_input_quantity',
                                                    ref:'ref_current_selected_item_quantity'})"
                                                    required
                                                    outline />  
                                        </v-flex>
                                        <v-btn :loading="input_adding_stock" @click="UPDATE_SELECTED_ITEM({item:CURRENT_SELECTED_ITEM,input,reload:true})" color="secondary" class="ml-2" :class="vs?.smAndDown?'mb-2':''">Add <v-icon>add</v-icon></v-btn>
                                    </v-layout>
                                </v-card>
                            </v-card-text> 

                             
                            <v-layout row wrap class="ma-0  mt-4">
                                <v-flex sm12 md6> 
                                    <v-card height="100%" hover :class="vs?.xs?'':'mr-2' "> 
                                        <v-layout justify-center align-center fill-height class="mbs-border primary lighten-5  pa-2" :style="'--size:1px; --color:grey; --conner:3px'"> 
                                            <mbs-keyboard 
                                                :type="'number'" 
                                                :column="vs?.xs?3:vs?.sm?4:5"
                                                :key_function="true"
                                                />
                                        </v-layout>
                                    </v-card>
                                </v-flex>
                                <v-flex sm12 md6>
                                    <v-card height="100%" hover class="mt-1">
                                        <v-layout column  class="ma-0" fill-height justify-center align-center>  
                                            <v-spacer></v-spacer>
                                            <v-btn @click="CONFIRM_REMOVE_ITEM(CURRENT_SELECTED_ITEM)"
                                                :disabled="!CURRENT_SELECTED_ITEM?.counted_stocks"
                                                class="font-weight-bold" :class="vs.xs?'':'my-2'"
                                                color="primary" :height="vs.smAndDown?'60':'70'" width="96%">
                                                <v-layout justify-center align-center> 
                                                    <v-icon class="mr-2">delete</v-icon>
                                                    <div class="not-f5 mt-1">Delete Counted Stock</div> 
                                                </v-layout>
                                            </v-btn>  
                                            <v-btn type="submit"
                                                class="font-weight-bold" :class="vs.xs?'my-1':'my-2'" 
                                                color="secondary" :height="vs.smAndDown?'60':'70'" width="96%">
                                                <v-layout justify-center align-center> 
                                                    <v-icon class="mr-2">mdi-upload</v-icon>
                                                    <div class="not-f5 mt-1">Update Item Stock</div> 
                                                </v-layout>
                                            </v-btn>   
                                        </v-layout> 
                                    </v-card>
                                </v-flex> 
                            </v-layout>   
                        </form>
                    </div> 
                </v-card> 
            </v-dialog>  
        </div>
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex" 
    import DB from "../../../plugins/DB";
    import Vue from "vue";
    const PAGE_NAME = "SELECT_ITEMS"

    export default {
        props:['height','item_data','item_sorting','selected_items','color','textColor','selling_model',
        'title','text','items','input_discount_amount','input_discount_percentage'],
        data(){
            return{
                show:false,   
                item_multiple_select:false,   
                dialog_edit_selected_item:false,   
                current_selected_item:null,   

                input:{},   
                input_adding_stock:false,   
                input_quantity:null,  
                input_quantity_location:null, 

                focused_field:null,  
                longClickTimer: null,
                longClickDetected: false, 

                selectedRows: [],
                lastSelectedRow: -1,
                editingCell: null,
            }
        },
        created(){ 
            try {
                this.MBS.events.$on('ON_SELECT_LOCAL_STOCK_TAKING_ITEM', this.ON_SELECT_LOCAL_STOCK_TAKING_ITEM);   
                this.MBS.events.$on('ON_QR_SCAN', this.ON_QR_SCAN);   
                this.MBS.events.$on('MBS_KEYBOARD', this.MBS_KEYBOARD); 
                this.MBS.events.$on('ADD_SELECTED_SELLING_ITEMS', this.ADD_SELECTED_SELLING_ITEMS); 
                this.MBS.events.$on('ADD_NEW_STOCK', this.ADD_NEW_STOCK); 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            this.OUTPUT() 
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                StockOrders: state=> state.items[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()],
                JoinedStockOrders: state=> state.join[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                StockTakingOrders: state=> state.items[(DATA.ITEMS.STOCK_TAKING_ORDERS.values).toUpperCase()],
                JoinedStockTakingOrders: state=> state.join[(DATA.ITEMS.STOCK_TAKING_ORDERS.values).toUpperCase()], 
                StockTakingItems: state=> state.items[(DATA.ITEMS.STOCK_TAKING_ITEMS.values).toUpperCase()],
                JoinedStockTakingItems: state=> state.join[(DATA.ITEMS.STOCK_TAKING_ITEMS.values).toUpperCase()], 
                LocalJoinedStockTaking: state=> state.items[(DATA.ITEMS.LOCAL_JOINED_STOCK_TAKING.values).toUpperCase()],
                LocalStockTakingItems: state=> state.items[(DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values).toUpperCase()],
                JoinedLocalStockTakingItems: state=> state.join[(DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values).toUpperCase()], 
            }), 
            StockOrdersData(){ 
                let StockOrders = this.StockOrders
                let JoinedStockOrders = this.JoinedStockOrders
                let items = JoinedStockOrders?JoinedStockOrders:StockOrders 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                return list
            }, 
            StockOutletsData(){  
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets  
                return items
            },  
            StockTakingOrdersData(){  
                let items = this.JoinedStockTakingOrders?this.JoinedStockTakingOrders:this.StockTakingOrders   
                if(!items){return null}  
                items = items.filter(item=>!item.closed)
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("operating_date",false)) 
                return list
            }, 
            StockTakingItemsData(){  
                const items = this.JoinedStockTakingItems?this.JoinedStockTakingItems:this.StockTakingItems 
                const filtered = this.JoinedStockTakingItems?.filter(item=>item?.stock_taking_key == this.thisStockTaking?.key ) 
                return filtered
            }, 
            LocalStockTakingItemsData(){  
                let items = this.JoinedLocalStockTakingItems?this.JoinedLocalStockTakingItems:this.LocalStockTakingItems  
                return items
            }, 
            thisStockTaking(){  
                let StockTakings = this.StockTakingOrdersData
                let LocalJoinedStockTaking = this.LocalJoinedStockTaking  
                if(!LocalJoinedStockTaking||!StockTakings){return null}
                let item = StockTakings.find(stock=>{
                    return stock.key == LocalJoinedStockTaking.key
                })  
                return item
            },  
            StockTakingUsers(){  
                let StockTakings = this.thisStockTaking 
                if(!StockTakings){return null}
                let users_obj = StockTakings.users
                let user_list = this.MBS.actions.OBJECT_ITEMS(users_obj) 
                if(!user_list){return null}
                let users = []
                user_list.forEach(us => {
                    let usd = this.$store.getters.getUserByUid(us.uid)
                    if (usd) {
                        users.push({
                            ...usd,
                            ...us,
                            joined_at_:this.MBS.actions.toDateTime(us.joined_at),
                            left_at_:us.left?this.MBS.actions.toDateTime(us.left_at):"Running.."
                        })
                    }else{
                        users.push({...us})
                    }
                }); 
                return users
            },
            thisUser(){  
                let users = this.StockTakingUsers 
                if(!users||!this.us){return null}
                let user = users.find(user=>user.uid == this.us.uid) 
                return user
            },

            //data
            ItemsData(){
                const Items = this.Items
                const JoinedItems = this.JoinedItems
                const data = JoinedItems?JoinedItems:Items
                return data 
            },
            MainInventoryItems(){ 
                const items = this.ItemData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const inventory = item.inventory_link_key == "main"
                    return inventory
                })  
                return filtered
            },
            AllInventoriesItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service&& !child && !parent
                    // return child
                })  
                return filtered
            },
            ItemsKits(){  
                let items = this.ItemsData 
                if(!items){return null}
                let filtered = items.filter(item=>!item.item_kits) 
                return filtered
            },   
            CheckedItems(){
                const SELECTED_ITEMS = this.SELECTED_ITEMS
                if(!SELECTED_ITEMS){return null}
                let filtered = SELECTED_ITEMS.filter(item=>item.checked)
                return filtered
            },
            ItemsSubmitted(){
                const online = this.StockTakingItemsData 
                const local = this.LocalStockTakingItemsData 
                let items = []
                if(online){ 
                    items.push(...online)
                }
                if (local) { 
                    const filtered = local?.filter(item=>{
                        if (item.uploaded) {
                            const index = items?.findIndex(it=>item.key == item.key) 
                            return index==-1?true:false
                        }
                        return false
                    })
                    items.push(...filtered)
                } 
                return items
            },
            ItemsOnLoading(){
               const items = this.LocalStockTakingItemsData 
               if(!items){ return null}   
               const filtered = items?.filter(item=>!item.uploaded)
               return filtered
            },
            ItemsCounted(){
               const submitted = this.ItemsSubmitted
               const onLoading = this.ItemsOnLoading 
               let all = []

                if (onLoading) {
                    onLoading.forEach(items => {
                        all.push({
                            ...items,
                            new_quantity:this.toNumber(items.new_quantity),
                        })
                    });  
                }

                if (submitted) { 
                    submitted.forEach(items => {
                        all.push({
                            ...items,
                            new_quantity:this.toNumber(items.new_quantity),
                            uploaded:true
                        })
                    }); 
                } 
               return all
            },
            ItemsNotSubmitted(){
               const ItemsSubmitted = this.ItemsSubmitted 
               const items = this.AllInventoriesItems 
               if(!items){ return null}
               let all = [] 
               items.forEach(item => {
                    let submitted = (key)=>{
                        if(!ItemsSubmitted){return null}
                        return ItemsSubmitted.find(item=>item.key==key)
                    }
                    if (!submitted(item.key)) {
                        all.push({
                            ...item,
                            new_quantity:this.toNumber(item.new_quantity),
                            not_submitted:true
                        }) 
                    }
               });   
               return all
            }, 
            ItemsNotCounted(){
               const ItemsCounted = this.ItemsCounted 
               const items = this.AllInventoriesItems 
               if(!items){ return null}
               let all = [] 
               items.forEach(item => {
                    let counted = (key)=>{
                        if(!ItemsCounted){return null}
                        return ItemsCounted.find(item=>item.key==key)
                    }
                    if (!counted(item.key)) {
                        all.push({
                            ...item,
                            new_quantity:item.new_quantity?this.toNumber(item.new_quantity):null,
                            item_not_counted:true
                        }) 
                    }
               });   
               return all
            }, 
            ItemsAll(){
               const ItemsCounted = this.ItemsCounted 
               const items = this.AllInventoriesItems 
               const counted = (key)=>ItemsCounted?.find(item=>item.key==key)
               if(!items){ return null}
               let all = [] 
               items.forEach(item => { 
                    let sub_item = counted(item.key)
                    if (sub_item) {
                        all.push({
                            ...item,
                            new_quantity:this.toNumber(sub_item.new_quantity)
                        }) 
                    }else{
                        all.push({
                            ...item,
                            new_quantity:item.new_quantity?this.toNumber(item.new_quantity):null 
                        }) 
                    }
               });   
               return all
            }, 



            FindStockTakingItems(){
                const items = this.ItemsAll  
                return (key,code)=>{
                    return items?.find(item=>key?item.key==key:item.code==code)
                }
            },
            FindLocalStockTakingItems(){
                const items = this.LocalStockTakingItems
                return (key,code)=>{
                    return items?.find(item=>key?item.key==key:item.code==code)
                }
            },
            SELECTED_ITEMS(){
                let item_data = this.item_data
                let item_sorting = this.item_sorting 
                
                return item_data
                // if (item_data) { 
                // }
                // const items = this.ItemsData 
                // return items
            },
            CURRENT_SELECTED_ITEM(){
                const current_selected_item = this.current_selected_item
                const ItemsOnLoading = this.ItemsOnLoading
                const ItemsSubmitted = this.ItemsSubmitted
                const ItemsAll = this.ItemsAll
                let selected = null 
                
                selected = ItemsOnLoading?.find(item=>item.key == current_selected_item?.key)
                if (!selected) {
                    selected = ItemsSubmitted?.find(item=>item.key == current_selected_item?.key)
                } 
                if (!selected) {
                    selected = ItemsAll?.find(item=>item.key == current_selected_item?.key)
                }
                return selected
            }
              
        },
        methods:{ 
            handleKeyDown(event) {
                // if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                //     event.preventDefault();
                // }
            },
            isEditing(rowIndex, columnIndex) {
            return this.editingCell && this.editingCell.row === rowIndex && this.editingCell.column === columnIndex;
            },
            startEditing(rowIndex, columnIndex) {
            this.editingCell = { row: rowIndex, column: columnIndex };
            this.$nextTick(() => this.$refs.editField.focus());
            },
            stopEditing(rowIndex, columnIndex) {
            this.editingCell = null;
            },
            selectRow(index) {
                if (this.lastSelectedRow !== -1 && this.$root.shiftKey) {
                    const start = Math.min(this.lastSelectedRow, index);
                    const end = Math.max(this.lastSelectedRow, index);
                    this.selectedRows = [];

                    for (let i = start; i <= end; i++) {
                    this.selectedRows.push(i);
                    }
                } else if (this.selectedRows.includes(index)) {
                    this.selectedRows.splice(this.selectedRows.indexOf(index), 1);
                } else {
                    this.selectedRows.push(index);
                } 
                this.lastSelectedRow = index;
            },


            startLongClick() {
                this.longClickTimer = setTimeout(() => {
                    this.longClickDetected = true;
                    this.item_multiple_select = !this.item_multiple_select;
                    console.log('Long click detected');
                }, 1000); 
            },
            endLongClick() {
                clearTimeout(this.longClickTimer);
                setTimeout(() => { 
                    this.longClickDetected = false;
                }, 10);
            },
 
            ON_EDIT_SELECTED_ITEM(item){
                try {  
                    this.input = {}
                    this.input_quantity = ""
                    let input_quantity_location = "Main Location"
                    this.input_adding_stock = false
                    if (!this.longClickDetected) {
                        this.current_selected_item = null 
                        let index = 1
                        if (item.joined_counted_stocks) {
                            index = this.MBS.actions.SIZE(item.joined_counted_stocks)+1
                        } 
                        input_quantity_location = input_quantity_location+" "+index
                        this.input_quantity_location = input_quantity_location
                        setTimeout(() => {
                            this.dialog_edit_selected_item = true
                            this.current_selected_item = {...item}   
                        }, 30);
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_EDIT_SELECTED_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            CONFIRM_REMOVE_ITEM(selected_item,index){
                try { 
                    this.dialog_edit_selected_item = false
                    // this.$emit("confirm_remove_item",selected_item,index)
                    this.REMOVE_ITEM(selected_item)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_REMOVE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            REMOVE_ITEM(data){
                try { 
                    // this.$emit("remove_item",data)
                    let company = this.SELECTED_COMPANY
                    let company_key = company?company.company_key:null
                    console.log(company,'c........');
                    console.log(data,'delete item,..........');

                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_SALES_ITEMS.values,
                        key:data.key,
                        update_locals:true,
                        // company_key:company_key, 
                    }).then(res=>{
                        console.log(res,'res........');
                    }).catch(error=>{
                        console.log(error,'error...........');
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'REMOVE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            FOCUS_INPUT(field){
                this.focused_field = field 
            },
            INPUT_UPDATE(event,item,check_item){
                try { 
                    let target = event?event.target:null
                    let value = target?target.value:null
                    if(check_item){
                        item = {
                            ...item,
                            checked:event?true:false
                        }
                        value = item.quantity
                    }
                    this.UPDATE_SELECTED_ITEM({
                        item:item,
                        quantity:value,
                        discount:item.discount,
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_SELECTED_SELLING_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            async ADD_NEW_STOCK(payload){
                try { 
                    const company = this.SELECTED_COMPANY
                    const company_key = company?.company_key

                    
                    const stock_take = this.thisStockTaking
                    const stock_taking_key = stock_take?.key
                    const stock_taking_outlet_code = stock_take?.outlet_code
                    const item = payload?.item 
                    const items = payload?.items 
                    const type = payload?.type 
                    const input_quantity = type == "auto_zero"?0:this.toNumber(this.input_quantity)
                    const input_quantity_location = type == "auto_zero"?"Auto Zero ":this.input_quantity_location
                    const us = this.us
                    const uid = us?.uid
                    const moment = this.MBS.date.moment
                    const key = moment?moment().valueOf():null

                    this.input_adding_stock = true
                    const updateItems = update_items=>{
                        if(!updateItems){return null}
                        let updating_items = [] 
                        update_items.forEach(update_item => {
                            let updating_item = {...update_item}
                            if (updating_item.new_counted_stocks) {
                                updating_item.new_counted_stocks.push({
                                    key,uid,
                                    counted_stock_quantity:input_quantity,
                                    counted_stock_quantity_location:input_quantity_location,
                                    local_created_at:key
                                })
                                updating_items.push({
                                    ...updating_item,
                                    local_updated_at:key, 
                                    stock_taking_key,
                                    stock_taking_outlet_code
                                }) 
                            }else{ 
                                updating_items.push({
                                    stock_taking_key,
                                    stock_taking_outlet_code,
                                    local_created_at:key,
                                    local_updated_at:key,
                                    company_key,
                                    key : updating_item?.key,
                                    item_key : updating_item?.key,
                                    code : updating_item?.code,
                                    item_code : updating_item?.code,
                                    name : updating_item?.name,
                                    counted_stocks : updating_item.counted_stocks?updating_item.counted_stocks:null,
                                    new_counted_stocks : [
                                        {
                                            key,uid,
                                            counted_stock_quantity:input_quantity,
                                            counted_stock_quantity_location:input_quantity_location,
                                            local_created_at:key
                                        }
                                    ]
                                })
                            }
                            
                        });
                        return updating_items
                    }
                    const updating_items = updateItems(items?items:[item]) 
                    if (!updating_items) {
                        let mbs_text = this.MBS.text.error_0
                        this.MBS.actions.dialog({
                            show:true,
                            icon:"error",
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                        })
                        this.input_adding_stock = false
                        return
                    } 

                    console.log(updating_items,'updating_items............');
                    

                    let res = await DB.addItems({
                        data:updating_items,
                        name:DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values, 
                        update_locals:true,   
                    })
                    let data_after = res?.data_after
                    if (item) {
                        let item_after = data_after?.find(it=>it.key == item.key)
                        return item_after  
                    }
                    return data_after
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_NEW_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            async UPDATE_SELECTED_ITEM(payload){
                try {
                    const reload = payload?.reload
                    const item_after = await this.ADD_NEW_STOCK(payload)
                    this.dialog_edit_selected_item = false
                    if(reload){
                        let res_item = await this.$store.dispatch("join_stock_taking_items",{data:item_after})
                        let joined_item = res_item.data  
                        setTimeout(() => {
                            this.ON_EDIT_SELECTED_ITEM(joined_item) 
                        }, 10);
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_SELECTED_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 


            //---------------[MAIN FUNCTIONS]------------   
            ON_SELECT_LOCAL_STOCK_TAKING_ITEM(payload){
                try {
                    const items = this.ItemsAll
                    const select_item = payload?.select_item
                    const local_select_item = payload?.local_select_item
                    const search_item = local_select_item?local_select_item:select_item
                    const item_key = search_item?.item_key?search_item?.item_key:search_item?.key
                    const item_code = search_item?.item_code?search_item?.item_code:search_item?.code
                    
                    const selected_item = this.FindStockTakingItems(item_key, item_code)
                    if(!selected_item){ 
                        this.MBS.actions.dialog({
                            show:true,
                            title:'ERROR',
                            text:"Item ("+item_code+") not found",
                            btnYes:"OKAY"
                        })  
                        return 
                    }
                    this.ON_EDIT_SELECTED_ITEM(selected_item) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SELECT_LOCAL_STOCK_TAKING_ITEM',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            ON_QR_SCAN(code){
                try {
                    if (code) {  
                        
                        let size = this.MBS.actions.SIZE(code)
                        if (size<3) { 
                        }else{  
                             
                        }
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_QR_SCAN',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            MBS_KEYBOARD(key){ 
                let focused_field = this.focused_field
                const field_value = focused_field?focused_field.value:null
                let current_value = "" 
                const ref_inputs = this.$refs

                if (key ) {
                    let value = key.value 
                    if (field_value) { 
                        if (field_value == "field_input_quantity") {
                            current_value = this.input_quantity
                            if(!current_value){
                                current_value=""
                            }else{

                            }

                            if (value=="BACK_SPACE") {
                                current_value = (""+current_value).slice(0,-1) 
                            } else {
                                current_value = current_value+""+value 
                            } 
                            this.input_quantity = current_value
                            // Vue.set(this.input, 'counted_stock_quantity', current_value); 
                        }else if (field_value == "field_input_quantity_location") {
                            current_value = this.input_quantity_location
                            if(!current_value){
                                current_value=""
                            }else{

                            }

                            if (value=="BACK_SPACE") {
                                current_value = (""+current_value).slice(0,-1) 
                            } else {
                                current_value = current_value+""+value 
                            } 
                            this.input_quantity_location = current_value
                            // Vue.set(this.input, 'counted_stock_quantity', current_value); 
                        }else{
                            if(!this.input){this.input={}}
                            if (value=="BACK_SPACE") {
                                current_value = (this.input[field_value]?this.input[field_value]+'':'').slice(0,-1)
                            }else{
                                current_value = (this.input[field_value]?this.input[field_value]:'')+value 
                            }
                            Vue.set(this.input,field_value, current_value);    
                        }
                        
                    }
                }
            },
            OUTPUT(){ 
                try {
                    let selected_items = this.SELECTED_ITEMS
                    let checked_items = this.CheckedItems 
                    this.$emit("input",{
                        selected_items:selected_items,
                        checked_items:checked_items,
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'OUTPUT',
                        page:PAGE_NAME, 
                    }) 
                }
            },
        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_SELECT_LOCAL_STOCK_TAKING_ITEM', this.ON_SELECT_LOCAL_STOCK_TAKING_ITEM);  
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);    
                this.MBS.events.$off('ADD_SELECTED_SELLING_ITEMS', this.ADD_SELECTED_SELLING_ITEMS);    
                this.MBS.events.$off('ADD_NEW_STOCK', this.ADD_NEW_STOCK);    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{ 
            item_multiple_select(value){
                this.$emit("item_multiple_select",value?true:false)
            },
            CheckedItems(value){
                this.$emit("checked_items",value)
                this.OUTPUT()
            },
            SELECTED_ITEMS(value){
                this.OUTPUT()
            }
        } 
    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 